import { generateMessage, handleErrorMessage } from '../utils/utils';
import api from './api';

const MICRO_SERVICE_URL_IMPORT = "inter-importacao";
class UploadService {
    async sendCsvUpload(fileList, vue, resourceName, options = {}) {
        let form = new FormData();
        let files = fileList.files;
        let param = 'file';
        const query = new URLSearchParams(options);
        const user = JSON.parse(localStorage.getItem('user'));

        if (user && user.email) query.append('importerEmail', user.email);

        for (var indice = 0; indice < files.length; indice++) {
            form.append(param, files[indice]);
        }

        try {
            const response = await api.post(`${MICRO_SERVICE_URL_IMPORT}/api/file/import/${resourceName}?${query.toString()}`, form)
            if (response.status == 202) {
                switch (resourceName) {
                    case 'funds-shareholders':
                        if (vue.$route.name != 'fundos-history') {
                            vue.$router.push({ name: 'fundos-history' });
                        }
                        break;
                    case 'distributor':
                        if (vue.$route.name != 'distribuidores-history') {
                            vue.$router.push({ name: 'distribuidores-history' });
                        }
                        break;
                }
                generateMessage("Arquivo(s) enviado(s) para processamento", "SUCCESS", vue);
            }
        } catch (error) {
            generateMessage(handleErrorMessage(error), "ERROR", vue)
        }

    }
    async getCsvModel(resourceName, fileName, options = {}) {
        const query = new URLSearchParams({
            ...options,
            version: 'v1'
        });

        const response = await api.get(`${MICRO_SERVICE_URL_IMPORT}/api/file/download/${resourceName}/template?${query.toString()}`, { responseType: 'blob' });
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
    }

}

export default new UploadService();